import { Component, inject, input, InputSignal, WritableSignal } from '@angular/core';
import { Map } from '../map/map';
import { WebSocketService } from '../../services/websocket-service';
import { TrainingSectionType } from '../../models/training-section.model';

@Component({
  selector: 'app-screen-map',
  imports: [Map],
  template: `<app-map [trainingSections]="trainingSections()" />`,
})
export class ScreenMap {
  readonly wsService: WebSocketService = inject(WebSocketService);
  readonly routeCoordinates: WritableSignal<[number, number][]> = this.wsService.routeCoordinates;
  readonly trainingSections: InputSignal<TrainingSectionType[]> = input.required();
}
